import { IMatrixGraphProps } from 'affiny-core/helpers/graphs';
import { EGender } from 'affiny-core/modules/account/types';
import {
  IGraph,
  IMatrix,
} from 'affiny-core/modules/api/models/compatibilityReport/compatibilityReport.types';
import { IPosition } from 'affiny-core/modules/api/models/member/member.types';

export enum EValuesSectionTitles {
  SIMILAR = 'similarValues',
  DIFFERENT = 'differentValues',
  OTHER = 'valuesSystem',
}

export enum EVisionSectionTitles {
  SIMILAR = 'similarVision',
  DIFFERENT = 'differentVision',
  FAMILY_RELIGION = 'familyReligion',
}

export interface IHorizontalBarProps {
  color: string;
  compatibilityValue?: number;
  label?: string;
}

export interface IHorizontalBarPairOwnProps {
  myCompatibilityValue?: number;
  otherCompatibilityValue?: number;
  otherGender: EGender;
  title?: string;
  titleStart?: string;
  titleEnd?: string;
}

export interface IVerticalBarProps {
  borderColor: string;
  color: string;
  compatibilityValue?: number;
  label?: string;
}

export interface IVerticalBarPairsOwnProps {
  matrices: IMatrix[];
  otherGender: EGender;
}

export interface ICompatibilityChartOwnProps extends IMatrixGraphProps {
  myCompatibilityValue: IPosition;
  myLabel: string;
  otherCompatibilityValue: IPosition;
  otherLabel: string;
}

export interface IChartCardProps {
  analysis?: string[];
  nickname?: string;
  title: string;
  children: React.ReactNode;
}

export interface ICompatibilityReportTabProps {
  nickname?: string;
  accountId: string;
  score?: number;
  wantedGender?: EGender;
}

export interface ICollapsibleAnalysisProps {
  analyses: string[];
  nickname: string;
}

export interface IGraphCardProps {
  graph: IGraph;
  wantedGender: EGender;
  nickname: string;
}
